import {useEffect, useState} from 'react';
import {
    Column,
    Row,
    Wrapper,
    WrapperCard,
    WrapperContent,
    WrapperSubHeader
} from "../../../components/common";
import BreadCrumbComponent from "../../../components/common/BreadCrumbComponent/BreadCrumbComponent.tsx";
import {ContactDetailsContainer} from "../../Contact/ContactDetails/ContactDetailsContainer.tsx";
import {IoMdArrowBack} from "react-icons/io";
import {Grid, styled, Tooltip} from "@mui/material";
import {FaRegEdit} from "react-icons/fa";
import {RiDeleteBin5Line} from "react-icons/ri";
import {useNavigate, useParams} from "react-router-dom";
import useResponsive from "../../../hooks/useResponsive.ts";
import {axiosFunction} from "../../../components/commonFunctions";
import {v2ReactURL} from "../../../utils/constant.ts";
import {ErrorState} from "../../Contact/AddContact/AddContact.tsx";
import {apiResponseHandler} from "../../../utils/functions/apiResponseHandler.ts";
import {CampaignDetailsType} from "../EditCampaign/EditCampaignSchema.ts";
import ErrorPage from "../../Error/ErrorPage.tsx";
import Loader from "../../../utils/Loader.tsx";
import {deleteCampaign} from "../../../components/commonFunctions/VLoyalty/deleteCampaign.ts";
import {useSelector} from "react-redux";
import {convertToSelectedTimeZoneIntoDate} from "../../../utils/timeZoneUtil.ts";
import {VscPercentage} from "react-icons/vsc";
import {MdCurrencyRupee} from "react-icons/md";

const TitleStyle = styled(Grid)({
    background: " #EBEDF3",
    textTransform: "capitalize",
    padding: "5px 10px",
    fontSize: "13px",
    fontWeight: 500,
    color: "#131313",
});
const DescriptionStyle = styled(Grid)({
    padding: "5px 10px",
    fontSize: "13px",
    fontWeight: 500,
    color: "#131313",
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
});

const CampaignDetails = () => {
    const decimalPoint = useSelector((state: any) => state.sessionData.sessionScope.decimalPoint);
    const timeZone = useSelector((state: any) => state.sessionData.sessionScope.timeZone || "Asia/Kolkata");
    const navigate = useNavigate();
    const params = useParams();
    const isMobile = useResponsive();
    const [campaignDetail, setCampaignDetail] = useState<CampaignDetailsType | null>(null);
    const [isLoading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<ErrorState | null>(null);
    const [permissions, setPermissions] = useState<{ isEdit: boolean; isDelete: boolean }>({
        isEdit: false,
        isDelete: false,
    });

    useEffect(() => {
        const fetchCampaignDetails = async () => {
            const response = await axiosFunction(
                `${v2ReactURL}/loyalty/campaign/${params.campaignId}`,
                "GET",
            );

            const error: ErrorState | null = apiResponseHandler(response, false);
            if (error != null) {
                setError(error);
                return;
            }
            setLoading(false);
            setError(null);
            setCampaignDetail(response.data.response.campaign);
            setPermissions({
                isEdit: Boolean(response.data.response.isEdit),
                isDelete: Boolean(response.data.response.isDelete),
            });
        }
        fetchCampaignDetails();
    }, []);

    const handleBackBtn = () => {
        navigate("/loyalty");
    };

    const handleDeleteCampaign = async () => {
        let boolean = await deleteCampaign(parseInt(params?.campaignId || "0"));
        if (boolean) {
            navigate("/loyalty")
        }
    }

    if (error) {
        return <ErrorPage error={error}/>;
    }

    if (isLoading) {
        return <Loader/>;
    }
    return (
        (
            <Wrapper navUrl="">
                <WrapperSubHeader>
                    <Column md={8}></Column>
                    <Column md={2}></Column>
                    <Column md={2} className="pl-md-0 mt-1 mt-md-0"></Column>
                </WrapperSubHeader>

                <WrapperContent>
                    <BreadCrumbComponent
                        type={'Campaign'}
                        typeLink={"/loyalty"}
                    />
                    <Row>
                        <WrapperCard>
                            <ContactDetailsContainer>
                                <div className="details-page-top-btn">
                                    <div className="left-side-btn">
                                        <IoMdArrowBack
                                            className="back-btn"
                                            onClick={handleBackBtn}
                                            size={24}
                                        />
                                        <span>Campaign Details</span>
                                    </div>

                                    <div className="right-side-btn">
                                        {permissions.isEdit &&
                                            <Tooltip title="Edit">
                                                <button
                                                    onClick={() => navigate(`/loyalty/campaign/${params.campaignId}/edit`)}
                                                    className="customBtn btn-sm btn bg-blue">
                                                    <FaRegEdit size={isMobile ? 14 : 16}/>
                                                </button>
                                            </Tooltip>
                                        }
                                        {permissions.isDelete &&
                                            <Tooltip title="Delete">
                                                <button
                                                    onClick={handleDeleteCampaign}
                                                    className="customBtn btn-sm btn bg-red">
                                                    <RiDeleteBin5Line size={isMobile ? 14 : 16}/>
                                                </button>
                                            </Tooltip>
                                        }
                                    </div>
                                </div>

                                <div>
                                    <div style={{margin: "10px", marginBottom: "100px"}}>
                                        <Grid container item lg={12} spacing={2}>
                                            <Grid item lg={6}>
                                                <Grid
                                                    container
                                                    item
                                                    lg={12}
                                                    style={{border: "1px solid #EBEDF3", marginBottom: "10px"}}
                                                >
                                                    <TitleStyle item lg={4} xs={5}>
                                                        Name:
                                                    </TitleStyle>
                                                    <DescriptionStyle item lg={8} xs={7}>
                                                        {campaignDetail?.name}
                                                    </DescriptionStyle>
                                                    <TitleStyle item lg={4} xs={5}>
                                                        Redemption Point:
                                                    </TitleStyle>
                                                    <DescriptionStyle item lg={8} xs={7}>
                                                        {campaignDetail?.points?.toFixed(decimalPoint || 2)}
                                                    </DescriptionStyle>
                                                    <TitleStyle item lg={4} xs={5}>
                                                        Type:
                                                    </TitleStyle>
                                                    <DescriptionStyle item lg={8} xs={7}>
                                                        {campaignDetail?.type}
                                                    </DescriptionStyle>
                                                    <TitleStyle item lg={4} xs={5}>
                                                        Discount Value:
                                                    </TitleStyle>
                                                    <DescriptionStyle item lg={8} xs={7}>
                                                        {campaignDetail?.type === "Discount" ? (
                                                                campaignDetail.discountInPercentage ?
                                                                    (<> {campaignDetail?.discount?.toFixed(decimalPoint || 2)}<VscPercentage/></>) :
                                                                    (<><MdCurrencyRupee/>{campaignDetail?.discount?.toFixed(decimalPoint || 2)}</>)
                                                            ) :
                                                            campaignDetail?.discount?.toFixed(decimalPoint || 2)
                                                        }
                                                    </DescriptionStyle>
                                                    <TitleStyle item lg={4} xs={5}>
                                                        Description:
                                                    </TitleStyle>
                                                    <DescriptionStyle item lg={8} xs={7}>
                                                        {campaignDetail?.description || "N/A"}
                                                    </DescriptionStyle>
                                                </Grid>
                                            </Grid>
                                            <Grid item lg={6}>
                                                <Grid
                                                    container
                                                    item
                                                    lg={12}
                                                    style={{border: "1px solid #EBEDF3", marginBottom: "10px"}}>
                                                    <TitleStyle item lg={4} xs={5}>
                                                        Redemption Per Customer:
                                                    </TitleStyle>
                                                    <DescriptionStyle item lg={8} xs={7}>
                                                        {campaignDetail?.redemptionType}
                                                    </DescriptionStyle>
                                                    <TitleStyle item lg={4} xs={5}>
                                                        Minimum Purchase Amount:
                                                    </TitleStyle>
                                                    <DescriptionStyle item lg={8} xs={7}>
                                                        {campaignDetail?.minPurchaseAmount?.toFixed(decimalPoint || 2)}
                                                    </DescriptionStyle>
                                                    <TitleStyle item lg={4} xs={5}>
                                                        Campaign Launch Date:
                                                    </TitleStyle>
                                                    <DescriptionStyle item lg={8} xs={7}>
                                                        {campaignDetail?.launchDate ? convertToSelectedTimeZoneIntoDate(campaignDetail?.launchDate, timeZone) : "N/A"}
                                                    </DescriptionStyle>
                                                    <TitleStyle item lg={4} xs={5}>
                                                        Campaign Expiry Date:
                                                    </TitleStyle>
                                                    <DescriptionStyle item lg={8} xs={7}>
                                                        {campaignDetail?.expiryDate ? convertToSelectedTimeZoneIntoDate(campaignDetail?.expiryDate, timeZone) : "N/A"}
                                                    </DescriptionStyle>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </div>
                            </ContactDetailsContainer>
                        </WrapperCard>
                    </Row>
                </WrapperContent>
            </Wrapper>
        )
    );
};

export default CampaignDetails;